function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M17.5,35 C7.83501688,35 0,27.1649831 0,17.5 C0,7.83501688 7.83501688,0 17.5,0 C27.1649831,0 35,7.83501688 35,17.5 C35,27.1649831 27.1649831,35 17.5,35 Z M24.6909789,11.6695479 L26.053102,11.6695479 C26.557362,11.6695479 26.9661455,11.2607644 26.9661455,10.7565044 C26.9661455,10.2522445 26.557362,9.84346097 26.053102,9.84346097 L22.4009281,9.84346097 C21.8966681,9.84346097 21.4878846,10.2522445 21.4878846,10.7565044 L21.4878846,14.4086784 C21.4878846,14.9129384 21.8966681,15.3217218 22.4009281,15.3217218 C22.9051881,15.3217218 23.3139716,14.9129384 23.3139716,14.4086784 L23.3139716,12.8704575 C25.3256763,15.3419946 25.7552028,18.8173155 24.2776243,21.7515966 C22.5516714,25.1791176 18.6832043,26.9556516 14.9586676,26.0311843 C11.234131,25.1067169 8.6453882,21.7274387 8.72250708,17.8906606 C8.79962596,14.0538825 11.5220693,10.7813586 15.2807462,10.0073032 C15.7746417,9.90559118 16.0925693,9.42275586 15.9908573,8.92886032 C15.8891453,8.43496478 15.40631,8.1170372 14.9124144,8.2187492 C10.3184761,9.16481697 6.9910453,13.1645684 6.89678889,17.8539638 C6.80253248,22.5433593 9.96655142,26.6735882 14.5187629,27.8034928 C19.0709744,28.9333973 23.7991008,26.7620779 25.9085989,22.5728856 C27.7242368,18.9672619 27.1838394,14.6932383 24.6909789,11.6695479 Z"
})));

const SvgRestartSessionHoverIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "35px",
  height: "35px",
  viewBox: "0 0 35 35",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgRestartSessionHoverIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/restart-session-hover-icon.e72f1f11.svg";
export { ForwardRef as ReactComponent };